<template>
  <div class="d-flex">
    <v-spacer />
    <div :class="containerClasses">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnchorRightContent',
  props: {
    containerClasses: {
      type: String,
      default: 'ma-4',
    },
  },
};
</script>
